import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Live from "../pages/live/page";
import ArticleDetail from "../pages/article/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/live",
        element: <Live />,
      },
      {
        path: "/article/:id",
        element: <ArticleDetail />,
      },
      {
        path: "/about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;